import React, { useState, useEffect } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useVendor } from "contexts/vendor.context";
import { getFrontendPortalUrl } from "services/config.service";

const Header: React.FC = () => {
  const { vendor } = useVendor();
  const [mobileNavActive, setMobileNavActive] = useState(false);

  // Toggle mobile nav
  const toggleMobileNav = () => setMobileNavActive(prev => !prev);

  // Close mobile nav when a link is clicked
  const handleLinkClick = () => {
    if (mobileNavActive) setMobileNavActive(false);
  };

  // Add/remove body class for mobile nav
  useEffect(() => {
    const body = document.body;
    if (mobileNavActive) body.classList.add("mobile-nav-active");
    else body.classList.remove("mobile-nav-active");

    return () => body.classList.remove("mobile-nav-active");
  }, [mobileNavActive]);

  return (
    <header className="header d-flex align-items-center fixed-top">
      <div className="container-fluid container-xl d-flex align-items-center justify-content-between">
        <a href="/" className="logo d-flex align-items-center">
          <h1 className="sitename modern-logo">{vendor?.company_name}</h1>
        </a>

        <nav className={`navmenu ${mobileNavActive ? "mobile-nav-active" : ""}`}>
          <ul>
            <li>
              <a href="/" onClick={handleLinkClick}>
                <i className="bi bi-house"></i> Home
              </a>
            </li>

            <li>
              <a href="/overview" onClick={handleLinkClick}>
                <i className="bi bi-card-list"></i> Overview
              </a>
            </li>

            <li>
              <a href="/services" onClick={handleLinkClick}>
                <i className="bi bi-tools"></i> Services
              </a>
            </li>

            <li>
              <a href={`${getFrontendPortalUrl()}/#/verify-email?action=onboard-vendor`} onClick={handleLinkClick}>
                <i className="bi bi-people"></i> Sub Vendor
              </a>
            </li>

            <li>
              <a href="/contact" onClick={handleLinkClick}>
                <i className="bi bi-briefcase-fill"></i> Contact Us
              </a>
            </li>

            <li>
              <a
                href="https://wa.me/9437788017"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleLinkClick}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/assets/img/whatsapp.png`}
                  alt="Whatsapp"
                  style={{
                    width: "16px",
                    marginRight: "4px"
                  }}
                /> WhatsApp Us
              </a>
            </li>

            <li>
              <a href={`${getFrontendPortalUrl()}/#/verify-email?action=portal-login`} onClick={handleLinkClick}>
                <i className="bi bi-arrow-right-square-fill"></i>
              </a>
            </li>
          </ul>

          <i className={`mobile-nav-toggle d-xl-none bi ${mobileNavActive ? "bi-x" : "bi-list"}`} onClick={toggleMobileNav}></i>

        </nav>
      </div>
    </header>
  );
};

export default Header;
